import { useEffect, useState } from "react";

// Treat as "mobile" if the primary pointer is coarse (touch) OR the viewport
// is narrow. Re-evaluates on resize so it stays correct on orientation change.
export function useIsMobile(maxWidth = 768): boolean {
  const [mobile, setMobile] = useState<boolean>(() => check(maxWidth));
  useEffect(() => {
    const onResize = () => setMobile(check(maxWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [maxWidth]);
  return mobile;
}

function check(maxWidth: number): boolean {
  if (typeof window === "undefined") return false;
  const coarse = window.matchMedia?.("(pointer: coarse)").matches ?? false;
  const narrow = window.innerWidth < maxWidth;
  // Phone-class device: coarse pointer AND narrow screen (avoid blocking laptops with touchscreens).
  return coarse && narrow;
}
